import { 
    claim_claim_create,
    claim_list_get,
    claim_limit_get,
    claim_userid_get,
    claim_claim_update
} from '../../Models/claim';

//====== ON CREATE CLAIM  ======
export const onCreateClaim = (data) => {
    return new Promise((resolve, reject) => {
        claim_claim_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//====== ON GET CLAIM LIST ======
export const onGetClaim = (data) => {
    return new Promise((resolve, reject) => {
        claim_list_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onGetClaimByLimit = (data) => {
    return new Promise((resolve, reject) => {
        claim_limit_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//====== GET CLAIM BY USERID =====
export const onGetClaimByUserid = (data) => {
    return new Promise((resolve, reject) => {
        claim_userid_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//====== ON UPDATE STATUS ======
export const onUpdateClaim = (data) => {
    return new Promise((resolve, reject) => {
        claim_claim_update(data)
        .then((response) => response.json())
        .then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}